module.exports = __webpack_public_path__ + "img/bg3.fa6b9696.jpg";